import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGenerateJobDescriptionResponse } from '../types';

export const generateJobDescription = async (
  postingId: string,
  officeId?: string,
): Promise<IGenerateJobDescriptionResponse> => {
  const headers: { Authorization: string; 'x-office'?: string } = await getAuthHeaders();
  const { data } = await tempMeeApi.post<IGenerateJobDescriptionResponse>(
    `/posting-service/postings/${postingId}/generate-description`,
    undefined,
    {
      headers: {
        ...headers,
        'x-office': officeId || headers['x-office'],
      },
    },
  );
  return data;
};
